module.exports = __webpack_public_path__ + "img/pulled-chicken-in-a-crock-pot.d4135896.jpg";